import React from 'react';
import PropTypes from 'prop-types';

import { SuiContainer } from '@splashthat/sui';

import FormEditorNodeDropzone from './FormEditorNodeDropzone';

const FormEditorNodeChildrenWrapper = (props) => {
    const { dragNodeId, dropNodeId, dropNodePosition, dragNodePosition } = props;

    if (!props.formNodeIds.length) {
        return null;
    }

    const elements = props.formNodeIds.reduce((memo, formNodeId, i) => {
        let showDropzoneBefore = false;
        let showDropzoneAfter = false;

        if (dropNodeId === formNodeId) {
            if (dragNodeId === dropNodeId) {
                showDropzoneBefore = true;
            } else if (dragNodePosition < dropNodePosition) {
                showDropzoneBefore = dropNodePosition <= i - 1;
                showDropzoneAfter = dropNodePosition >= i;
            } else {
                showDropzoneBefore = dropNodePosition <= i;
                showDropzoneAfter = dropNodePosition >= i + 1;
            }
        }

        const iterationChildren = [];

        // The after key of this iteration and before key of the next overlap intentionally,
        // that way React won't re-render a dropzone component.
        const dropzoneBeforeKey = i;
        const dropzoneAfterKey = i + 1;

        if (showDropzoneBefore) {
            iterationChildren.push(<FormEditorNodeDropzone key={dropzoneBeforeKey} />);
        }
        iterationChildren.push(
            // children function pattern, so we don't care what children are rendered from here.
            props.children(formNodeId, i),
        );
        if (showDropzoneAfter) {
            iterationChildren.push(<FormEditorNodeDropzone key={dropzoneAfterKey} />);
        }
        return memo.concat(iterationChildren);
    }, []);

    // Root node (depth 0) shouldn't cast shadow. Not a big deal, but prevents unnecessary shadow
    // around the tree.
    const shouldCastShadow = props.depth !== 0;
    const className = shouldCastShadow ? 'form-node-children-shadow' : '';

    return <SuiContainer className={className}>{elements}</SuiContainer>;
};

FormEditorNodeChildrenWrapper.propTypes = {
    formNodeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    dragNodeId: PropTypes.string,
    dropNodeId: PropTypes.string,
    dropNodePosition: PropTypes.number,
    dragNodePosition: PropTypes.number,
    depth: PropTypes.number.isRequired,
    children: PropTypes.func.isRequired,
};
FormEditorNodeChildrenWrapper.defaultProps = {
    dropNodePosition: null,
    dragNodePosition: null,
    dragNodeId: null,
    dropNodeId: null,
};

export default FormEditorNodeChildrenWrapper;
